var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c("div", { staticClass: "nuv" }, [
        _c(
          "a",
          { staticClass: "active", attrs: { href: "/tjkStudy/examlist" } },
          [_vm._v("考试中心")]
        ),
        _vm._v(">"),
        _c("span", [_vm._v(_vm._s(_vm.data.examName))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "exam-con" }, [
          _c("h2", [_vm._v(_vm._s(_vm.data.examName))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content" },
            [
              _vm._l(_vm.paperQuestion, function(l, key) {
                return [
                  _c(
                    "div",
                    { staticClass: "type" },
                    [
                      _c("div", { staticClass: "title" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.getNum(key)) +
                              "、" +
                              _vm._s(l.questionGroupTittle) +
                              "（共" +
                              _vm._s(l.questionDetailList.length) +
                              "题）共" +
                              _vm._s(l.totalScore) +
                              "分"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(l.questionDetailList, function(q, index) {
                        return _c(
                          "div",
                          { staticClass: "list" },
                          [
                            q.question
                              ? [
                                  q.questionType == "BlankFilling"
                                    ? [
                                        _c(
                                          "p",
                                          {
                                            attrs: {
                                              id: _vm.savelist[key][index].num
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.savelist[key][index].num
                                              ) + "、\n                    "
                                            ),
                                            _vm._l(
                                              q.question.questionContent
                                                .questionStem,
                                              function(s, k) {
                                                return [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.replaceNToBr(s)
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-input", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          k !=
                                                          q.question
                                                            .questionContent
                                                            .questionStem
                                                            .length -
                                                            1,
                                                        expression:
                                                          "k != q.question.questionContent.questionStem.length - 1"
                                                      }
                                                    ],
                                                    attrs: {
                                                      placeholder: "请输入答案"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.savelist[key][index]
                                                          .tjkAnswerString[k],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.savelist[key][
                                                            index
                                                          ].tjkAnswerString,
                                                          k,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "savelist[key][index].tjkAnswerString[k]"
                                                    }
                                                  })
                                                ]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ]
                                    : q.questionType == "BlankChoice"
                                    ? [
                                        _c(
                                          "p",
                                          {
                                            attrs: {
                                              id: _vm.savelist[key][index].num
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.savelist[key][index].num
                                              ) + "、\n                    "
                                            ),
                                            _vm._l(
                                              q.question.questionContent
                                                .questionStem,
                                              function(s, k) {
                                                return [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.replaceNToBr(s)
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          k !=
                                                          q.question
                                                            .questionContent
                                                            .questionStem
                                                            .length -
                                                            1,
                                                        expression:
                                                          "k != q.question.questionContent.questionStem.length - 1"
                                                      },
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.savelist[key][
                                                            index
                                                          ].tjkAnswerString[k],
                                                        expression:
                                                          "savelist[key][index].tjkAnswerString[k]"
                                                      }
                                                    ],
                                                    staticClass: "answer-input",
                                                    attrs: {
                                                      type: "text",
                                                      size: "1",
                                                      maxlength: "1",
                                                      placeholder: "请输入答案"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.savelist[key][index]
                                                          .tjkAnswerString[k]
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.savelist[key][
                                                            index
                                                          ].tjkAnswerString,
                                                          k,
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ]
                                    : [
                                        _c(
                                          "p",
                                          {
                                            attrs: {
                                              id: _vm.savelist[key][index].num
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.savelist[key][index].num
                                              ) + "、"
                                            ),
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.replaceNToBr(
                                                    q.question.questionContent
                                                      .questionStemString
                                                  )
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      ],
                                  _vm._v(" "),
                                  q.question.questionContent.imageUrlList
                                    ? _c(
                                        "p",
                                        [
                                          _vm._l(
                                            q.question.questionContent
                                              .imageUrlList,
                                            function(i) {
                                              return [
                                                i != ""
                                                  ? _c("img", {
                                                      staticClass: "s-img",
                                                      attrs: { src: i },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.clickImg(
                                                            $event
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  q.questionType == "SingleChoice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          _vm._l(
                                            q.question.questionContent.choices,
                                            function(value, k) {
                                              return _c(
                                                "p",
                                                [
                                                  _c(
                                                    "el-radio",
                                                    {
                                                      attrs: { label: k },
                                                      model: {
                                                        value:
                                                          _vm.savelist[key][
                                                            index
                                                          ].tjkAnswerString,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.savelist[key][
                                                              index
                                                            ],
                                                            "tjkAnswerString",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "savelist[key][index].tjkAnswerString"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(k) +
                                                          "、" +
                                                          _vm._s(value)
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    : q.questionType == "MultipleChoice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          [
                                            _c(
                                              "el-checkbox-group",
                                              {
                                                model: {
                                                  value:
                                                    _vm.savelist[key][index]
                                                      .tjkAnswerString,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.savelist[key][index],
                                                      "tjkAnswerString",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "savelist[key][index].tjkAnswerString"
                                                }
                                              },
                                              _vm._l(
                                                q.question.questionContent
                                                  .choices,
                                                function(value, k) {
                                                  return _c(
                                                    "p",
                                                    [
                                                      _c(
                                                        "el-checkbox",
                                                        { attrs: { label: k } },
                                                        [
                                                          _vm._v(
                                                            _vm._s(k) +
                                                              "、" +
                                                              _vm._s(value)
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : q.questionType == "TrueOrFalse"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          [
                                            _c(
                                              "el-radio-group",
                                              {
                                                model: {
                                                  value:
                                                    _vm.savelist[key][index]
                                                      .tjkAnswerString,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.savelist[key][index],
                                                      "tjkAnswerString",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "savelist[key][index].tjkAnswerString"
                                                }
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        attrs: { label: true }
                                                      },
                                                      [_vm._v("正确")]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        attrs: { label: false }
                                                      },
                                                      [_vm._v("错误")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : q.questionType == "BlankChoice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          _vm._l(
                                            q.question.questionContent.choices,
                                            function(value, k) {
                                              return _c("p", [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(k) +
                                                      "、" +
                                                      _vm._s(value)
                                                  )
                                                ])
                                              ])
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    : q.questionType == "ShortAnswer"
                                    ? [
                                        _c("div", { staticClass: "answer" }, [
                                          _c("p", [
                                            _vm._v("答案："),
                                            _c("textarea", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.savelist[key][index]
                                                      .tjkAnswerString,
                                                  expression:
                                                    "savelist[key][index].tjkAnswerString"
                                                }
                                              ],
                                              staticClass:
                                                "answer-input shortanswer",
                                              domProps: {
                                                value:
                                                  _vm.savelist[key][index]
                                                    .tjkAnswerString
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.savelist[key][index],
                                                    "tjkAnswerString",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            })
                                          ])
                                        ])
                                      ]
                                    : _vm._e()
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      })
                    ],
                    2
                  )
                ]
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("div", { staticClass: "count" }, [
          _c("h2", [_vm._v("统计")]),
          _vm._v(" "),
          _c("div", { staticClass: "useTime" }, [
            _c("p", [_vm._v("距自动交卷时间")]),
            _vm._v(" "),
            _c("span", { staticClass: "blue" }, [_vm._v(_vm._s(_vm.time))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "useTime" }, [
            _c("p", { staticClass: "txt" }, [
              _vm._v(
                "满分" +
                  _vm._s(_vm.data.totalScore) +
                  "分，" +
                  _vm._s(_vm.data.passScore) +
                  "分及格"
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(_vm.list, function(s) {
              return _c(
                "li",
                { class: { active3: _vm.getClass(s.tjkAnswerString) } },
                [
                  _c("a", { attrs: { href: "#" + s.num } }, [
                    _vm._v(_vm._s(s.num))
                  ])
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "btn" }, [
            _c("div", { staticClass: "hold", on: { click: _vm.saveExam } }, [
              _vm._v("保存")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "submit", on: { click: _vm.submitExam } },
              [_vm._v("提交试卷")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.showImg
        ? _c("zoom-img", {
            attrs: { imgSrc: _vm.imgSrc },
            on: { clickit: _vm.viewImg }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e757496", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e757496","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/exam.vue
// module id = 1117
// module chunks = 0